<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import { mapGetters, mapActions } from "vuex";
    import Drawer from "vue-simple-drawer";
    
    /**
     * Pricing component
     */
    export default {
      page: {
        title: "SMS packages",
        meta: [{ name: "description", content: appConfig.description }],
      },
      components: { Layout, PageHeader, Drawer },
      data() {
        return {
          buysuccess: false,
          confirm_pay: false,
          test: 0,
          open: false,
          openRightDrawer: false,
          isUpDrawer: false,
          isDownDrawer: false,
          title: "SMS Packages",
          selectedPack: {
            id: "",
            name: "",
            price: "",
            Phonenumber: "",
            country: "235",
            sms: "",
          },
          errors: {
            phone: "",
          },
          items: [
            {
              text: "Message center",
            },
            {
              text: "Buy sms",
              active: true,
            },
          ],
        };
      },
      methods: {
        ValidateInput() {
          if (
            isNaN(this.selectedPack.Phonenumber) ||
            this.selectedPack.Phonenumber == "-" ||
            this.selectedPack.Phonenumber == "+"
          ) {
            this.errors.phone = "Contact should only contain numbers";
          } else if (
            this.selectedPack.Phonenumber.toString().length < 9 &&
            this.selectedPack.country == "235"
          ) {
            this.errors.phone = "Your input should be 9 characters";
          } else {
            this.errors.phone = "";
          }
        },
        buySmsFunction() {
          if (this.selectedPack.Phonenumber == "") {
            this.errors.phone = "Please enter a valid phone number";
            return;
          }
          this.BuysmsPackages(this.selectedPack);
        },
        rightDrawer(pack) {
          if (pack == "close") {
            this.openRightDrawer = !this.openRightDrawer;
          } else {
            this.openRightDrawer = !this.openRightDrawer;
            this.selectedPack = {
              id: pack.id,
              name: pack.package,
              price: pack.total_cost,
              Phonenumber: this.selectedPack.Phonenumber,
              country: this.selectedPack.Phonenumber,
              sms: pack.sms,
            };
          }
        },
        handleToggleDrawer() {
          this.$refs.drawerLayout.toggle();
        },
        toggle() {
          this.open = !this.open;
        },
        thousandSeprator(m) {
          if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
            return m
              .toString()
              .replace(/\D/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          } else {
            return m;
          }
        },
        ...mapActions({
          FetchsmsPackages: "messages/fetchsmsPackages",
          BuysmsPackages: "messages/buysmsPackages",
        }),
      },
      computed: {
        ...mapGetters("messages", [
          "SmsPackages",
          "SendStatus",
          "purchase_id",
          "ConfirmStatus",
        ]),
      },
      created() {
        this.FetchsmsPackages();
      },
    };
    </script>
    <template>
      <Layout>
        <div class="form-group">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>
        <PageHeader :title="title" :items="items" />
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="text-center mb-5">
              <h4>Choose your sms package</h4>
              <p class="text-muted">Select an sms puckage to buy</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-for="pack in SmsPackages" :key="pack.id" class="col-xl-3 col-md-6">
            <div class="card plan-box">
              <div class="card-body p-4">
                <div class="media">
                  <div class="media-body">
                    <h5>{{ pack.package }}</h5>
                  </div>
                </div>
                <div class="py-4">
                  <h2>
                    <sup>
                      <small></small>
                    </sup>
                    {{ thousandSeprator(pack ? pack.total_cost : 0) }}/=
                    <span class="font-size-13 text-success"
                      >{{ pack.sms }} sms</span
                    >
                  </h2>
                </div>
                <div class="text-center plan-btn">
                  <a
                    @click="rightDrawer(pack)"
                    href="javascript: void(0);"
                    class="btn btn-warning btn-sm position-relative"
                    >Select <i class="fa fa-arrow-right"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Drawer
          @close="rightDrawer('close')"
          :align="'right'"
          :closeable="true"
          :maskClosable="true"
          :zIndex="1002"
        >
          <div v-if="openRightDrawer">
            <div class="offcanvas-header">
              <h4 class="offcanvas-title text-uppercase" id="offcanvasExampleLabel">
                Buy<b> {{ selectedPack.name }}</b>
              </h4>
            </div>
            <div class="offcanvas-body">
              <div>
                <div class="card">
                  <div class="card-body">
                    <div class="col-md-12">
                      <div class="col-md-12">
                        <b-card bg-variant="warning" class="text-white-50">
                          <div class="row">
                            <div class="col-md-6">
                              <h2 class="mt-0 mb-4 text-white">
                                <i class="mdi mdi-cash me-3"></i>
                                {{
                                  thousandSeprator(
                                    selectedPack
                                      ? thousandSeprator(selectedPack.price)
                                      : 0
                                  )
                                }}
                                /=
                              </h2>
                            </div>
                            <div class="col-md-6">
                              <h2 class="mt-0 mb-4 text-white">
                                <i class="mdi mdi-message-processing me-3"></i>
                                {{ selectedPack.sms }} sms
                              </h2>
                            </div>
                          </div>
                          <p class="text-light">
                            Enter your phone number that has money worthy
                            <b>{{
                              thousandSeprator(
                                selectedPack
                                  ? thousandSeprator(selectedPack.price)
                                  : 0
                              )
                            }}</b>
                            to buy
                            <b>{{ selectedPack.name }}</b>
                          </p>
                        </b-card>
                      </div>
                    </div>
                    <b-form>
                      <b-form-group
                        class="mb-3"
                        label="Mobile Money Number"
                        label-for="formrow-firstname-input"
                      >
                        <b-form-input
                          v-model="selectedPack.Phonenumber"
                          @input="ValidateInput()"
                          placeholder="Enter phone number e.g 256701512709"
                          id="formrow-firstname-input"
                          type="text"
                        ></b-form-input>
                        <p v-if="errors.phone" class="text-danger">
                          {{ errors.phone }}
                        </p>
                      </b-form-group>
    
                      <div>
                        <b-button v-if="errors.phone" variant="primary" disabled
                          >Submit <i class="fa fa-exclamation-triangle"></i
                        ></b-button>
                        <b-button v-else variant="primary" @click="buySmsFunction()"
                          >Submit
                          <b-spinner
                            v-if="SendStatus"
                            variant="light"
                            small
                            role="status"
                          ></b-spinner
                          ><i class="fa fa-check"></i
                        ></b-button>
                      </div>
                      <br />
                      <b-form-group v-if="purchase_id && ConfirmStatus == 0">
                        <b-alert show variant="primary">
                          Check your phone to confirm this payment by entering your
                          mobile money pin</b-alert
                        >
                      </b-form-group>
                    </b-form>
                    <div class="content" v-show="ConfirmStatus == 1">
                      <div class="wrapper-1">
                        <div class="wrapper-2">
                          <h1>Thank you <i class="fa fa-check"></i></h1>
    
                          <p>
                            Your payment for <b>{{ selectedPack.name }}</b> was
                            successfully recieved
                          </p>
                          <router-link to="/messages">
                            <button class="go-home">
                              Go to message center <i class="fa fa-arrow-right"></i>
                            </button>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Drawer>
      </Layout>
    </template>
    
    <style scoped>
    .wrapper-1 {
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;
    }
    .wrapper-2 {
      padding: 30px;
      text-align: center;
    }
    h1 {
      font-family: "Kaushan Script", cursive;
      font-size: 4em;
      letter-spacing: 3px;
      color: #34c38f;
      margin: 0;
      margin-bottom: 20px;
    }
    .wrapper-2 p {
      margin: 0;
      font-size: 1.3em;
      color: #aaa;
      font-family: "Source Sans Pro", sans-serif;
      letter-spacing: 1px;
    }
    .go-home {
      color: #fff;
      background: #34c38f;
      border: none;
      padding: 10px 50px;
      margin: 30px 0;
      border-radius: 30px;
      text-transform: capitalize;
      box-shadow: 0 10px 16px 1px rgba(174, 199, 251, 1);
    }
    
    @media (min-width: 360px) {
      h1 {
        font-size: 4.5em;
      }
      .go-home {
        margin-bottom: 20px;
      }
    }
    
    @media (min-width: 600px) {
      .content {
        max-width: 1000px;
        margin: 0 auto;
      }
      .wrapper-1 {
        height: initial;
        max-width: 620px;
        margin: 0 auto;
        margin-top: 50px;
        box-shadow: 4px 8px 40px 8px rgba(88, 146, 255, 0.2);
      }
    }
    </style>